import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCoin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 7.5v-1m0 10v1M14.165 9c-.432-.598-1.24-1-2.165-1h-.278C10.495 8 9.5 8.796 9.5 9.778v.076c0 .702.496 1.344 1.281 1.659l2.438.975c.785.314 1.281.956 1.281 1.658C14.5 15.17 13.462 16 12.182 16H12c-.925 0-1.733-.402-2.166-1M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
	})
});
export default SvgCoin;
